import { Component } from '@angular/core';
import { DashboardService } from './dashboard.service';

@Component({
  selector: 'app-padufa',
  templateUrl: './padufa.component.html',
  styleUrls: ['./padufa.component.scss']
})
export class PadufaComponent {
  currentStep: string = 'calendar';
  loading: boolean = false;

  constructor(private dashboardService: DashboardService) {}

  ngOnInit() {
    this.dashboardService.currentStep$.subscribe(step => {
      console.log("step", step);
      this.currentStep = step;
    });

    this.dashboardService.loading$.subscribe(loading => {
      console.log("loading", loading);
      this.loading = loading;
    });

    this.dashboardService.init();
    this.dashboardService.pdufaInformation().subscribe((res) => {
      console.log("res", res);
      this.dashboardService.hideLoading();
    });
  }
}
